<template>
	<div class="home">
		<div class="top">
			<van-popup v-model="show" get-container="body" :style="{ height: '85%',width: '90%' }"  :closeable="true">
				<div class="">
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">报备信息</div>
					<van-cell-group class="plr20">
						<van-cell title="审批者姓名" :value="showForm.intervieweeName" />
						<van-cell title="审批者电话" :value="showForm.intervieweePhone" />
						<van-cell title="入厂时间" :value="showForm.interviewTime" />
						<van-cell title="离开时间" :value="showForm.leaveTime" />
						<van-cell v-if="showForm.confirmTime" title="离矿时间" :value="showForm.confirmTime" />
					</van-cell-group>
					<!-- <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">来访单位信息</div> -->
					<van-cell-group class="plr20">
						<van-cell title="运输车队" :value="showForm.fleetName" />
						<van-cell title="运输物资" :value="showForm.goodsName" />
						<van-cell title="卸货地点" :value="showForm.unloadPlaceName" />
						<van-cell title="运输路线" :value="showForm.transportRouteName" />
						<van-cell title="紫金山入口" :value="showForm.entryName" />
						<van-cell title="车牌号" :value="showForm.plateNumber" />
					</van-cell-group>
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">访客信息</div>
					<div v-for="item,index in showForm.drivers" :key="index">
						<div class="bgwhite yellow2 ft30 pl30 bor-bt" style="height:6vh; line-height:6vh;">
							访客{{index+1}}
						</div>
						<van-cell-group class="plr20">
							<van-cell title="驾驶员姓名" :value="item.personName" />
							<van-cell title="身份证号" :value="item.personNo" />
							<van-cell title="访客电话" :value="item.personPhone" />	
							<!--健康码改为附件20240721-->
							<div class="flex alstart between mt20">
								<span class="ft30 w40">附件</span>
								<template v-if="item.healthCode.indexOf(';')!=-1">
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" v-for="(i,v) in item.healthCode.split(';')" :key="v"
											:src="showForm.imgUrl+i"  @click="imagePreview(item,v,1)" style="display: flex; padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
								<template v-else>
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.healthCode"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
							</div>
							<!--健康码改为附件20240721-->
							<!--屏蔽掉健康码相关信息20240721-->
							<div v-if="$globalJKM">							
								<van-cell title="籍贯" :value="item.nativePlace" />
								<van-cell title="目前居住地" :value="item.apartment" />							
								<van-cell title="发热咳嗽" :value="item.hasCough?'是':'否'" />							
								<div class="flex alstart between mt20">
									<span class="ft30 w40">健康码</span>
									<template v-if="item.healthCode.indexOf(';')!=-1">
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" v-for="(i,v) in item.healthCode.split(';')" :key="v"
												:src="showForm.imgUrl+i"  @click="imagePreview(item,v,1)" style="display: flex; padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
									<template v-else>
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.healthCode"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
								</div>
								
								<div class="flex alstart between mt20">
									<span class="ft30 w40">核酸检测报告</span>
									<template v-if="item.acidCode.indexOf(';')!=-1">
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" v-for="(i,v) in item.acidCode.split(';')" :key="v"
												:src="showForm.imgUrl+i"  @click="imagePreview(item,v,3)" style="display: flex; padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
									<template v-else>
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.acidCode"  @click="imagePreview(item,0,3)" style="padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
								</div>
							</div>
						</van-cell-group>
					</div>
					<div class="tc ptb10">
						<van-button type="danger" class=" tc" @click="show=false">关闭</van-button>
					</div>
				</div>
			</van-popup>
			<div class="homes">
				<van-tabs v-model="active" @click="initContent" color="#4597ff">
					<van-tab title="当前报备">
						<div>
							<van-popup v-model="nishow" get-container="#app" round position="center" :style="{ height: '70%',width: '90%' }" :close-on-click-overlay="false">
								<div class="m30 relative">
									<div class="ft30 bold ptb20 tc fixed w90" style="position: fixed !important;">
										<div class="tc">
											入厂人员安全告知
										</div>
									</div>
									<div class="ptb20 tc" style="height: 20px;">
									</div>
									<div class="ft28">
										<div class="">
											各位领导、客户及来访者，欢迎光临我司检查、参观、联系业务。为保证大家的人身健康与安全，请配合公司熟悉并遵守如下规定：
										</div>
										<div class="mt10">
											1、进入公司前请在公司值班室配合保安人员进行必要登记及出示相关证件。进入厂区、库区的所有车辆请按照限速标志行驶，并按照指定地点停放。严禁酒后进入公司。
										</div>
										<div class="mt10">
											2、请在指定地点（办公室或休息室吸烟点）吸烟，烟头要丢在烟灰缸内，厂区内禁止流动吸烟。
										</div>
										<div class="mt10">
											3、严禁携带易燃、易爆和其他危险化学品进入公司厂区、库区，进入库区人员请在库区入口处交出火种。
										</div>
										<div class="mt10">
											4、如需将公司物资带出厂，请主动出示《物资放行申请单》。
										</div>
										<div class="mt10">
											5、严禁私自进入生产区域，如需进入生产现场，请在公司陪同人员引导下沿指定的安全路线行走；进入生产现场，应遵守各种安全警示标志的提示，佩戴必要的劳动防护用品，做好个人防护。
										</div>
										<div class="mt10">
											6、公司配有医务室，如有身体不适，可立即联系身边的陪同人员。参观期间，如有火灾、地震等突发情况，您可就近拿取附件的救援物资使用。撤离时，请您听从陪同人员的引导，按照疏散指示有序撤离。
										</div>
										<div class="mt10">
											请您认真阅读安全告知，衷心感谢您的配合！
										</div>
										<div class="tc mt30">
											<van-tag type="success" size="large" @click="nishow=false">我已知晓</van-tag>
										</div>
									</div>
									
								</div>
							</van-popup>
							<div class="modals bggrey">
								<!-- <div class="bggrey"> -->
									<van-form ref="appForm" @submit="onSubmit"  @failed="failed" validate-trigger="onSubmit" label-align="center" :scroll-to-error="true" :validate-first="true">
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											报备信息
										</div>
										<van-field v-model="appForm.intervieweeName" name="审批者姓名" label="审批者姓名" placeholder="请输入审批者姓名"
											:required="true" :rules="[{ required: true, message: '请填写审批者姓名' }]" />
										<van-field v-model="appForm.intervieweePhone" name="审批者电话" label="审批者电话" placeholder="请输入审批者电话"
											:required="true" :rules="[{ required: true, message: '请填写审批者电话' }]" >
											<template #button>
											    <van-button size="small" type="primary" native-type="button" @click="checkPhone">校验</van-button>
											</template>
										</van-field>
										<van-field readonly clickable name="calendar" :value="appForm.interviewTime" label="入厂时间" :required="true"
											placeholder="点击选择时间" @click="openPicker(1)" :rules="[{ required: true, message: '请选择入厂时间' }]" />
										<van-field readonly clickable name="calendar" :value="appForm.leaveTime" label="离开时间" :required="true"
											placeholder="点击选择时间" @click="openPicker(2)" :rules="[{ required: true, message: '请选择离开时间' }]"/>
										<div id="screen1">
											<van-popup v-model="showCalendar" round position="bottom" get-container="#screen1" :safe-area-inset-bottom="true">
												<van-datetime-picker
													 v-if="showCalendar"
													 v-model="currentDate"
													 type="datetime"
													 title="选择时间"
													 item-height="7vh"
													 :min-date="minDate"
													 :max-date="maxDate"
													@confirm="onConfirm"
													@cancel="cancel"
												/>
											</van-popup>
										</div>
										<!-- <div class="pl30 ft28" style="height: 50px; line-height: 50px;">
											来访单位信息
										</div> -->
										<van-field v-model="fleet"  @click="openPicker1('C02')" label="运输车队" placeholder="请选择运输车队"
											:required="true" :rules="[{ required: true, message: '请选择运输车队' }]" />
										<van-field v-model="goods"  @click="openPicker1('C03')" label="运输物资" placeholder="请选择运输物资"
											:required="true" :rules="[{ required: true, message: '请选择运输物资' }]" />
										<van-field v-model="unloadPlace"  @click="openPicker1('C04')" label="卸货地点" placeholder="请选择卸货地点"
										:required="true" :rules="[{ required: true, message: '请选择卸货地点' }]" />
										<van-field v-model="transportRoute"  @click="openPicker1('C05')" label="运输路线" placeholder="请选择运输路线"
										:required="true" :rules="[{ required: true, message: '请选择运输路线' }]" />
										<van-field v-model="entry"  @click="openPicker1('C06')" label="紫金山入口" placeholder="请选择紫金山入口"
										:required="true" :rules="[{ required: true, message: '请选择紫金山入口' }]" />
										<van-field v-model="appForm.plateNumber" name="车牌号" label="车牌号" placeholder="请输入车牌号"
											:required="false" />
										<van-popup v-model="showPicker" round position="bottom" get-container="#app">
											<van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
										</van-popup>
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											访客信息
										</div>
										<div class="" v-for="item,index in appForm.drivers" :key="index">
											<div class="bgwhite yellow2 pl30 bor-bt ft28 flex between" style="height: 6.5vh; line-height: 6.5vh;">
												<span>访客{{index+1}}</span>
												<span class="red w30 tc" v-if="appForm.drivers.length>1" @click="delVis(index,item)">删除访客</span>
											</div>
											<van-field v-model="item.personName" name="驾驶员姓名" label="驾驶员姓名" placeholder="请输入驾驶员姓名"
												:required="true" :rules="[{ required: true, message: '请填写驾驶员姓名' }]" />
											<van-field v-model="item.personNo" name="身份证号" label="身份证号" placeholder="请输入身份证号"
												:required="true" :rules="[{ required: true, message: '请填写身份证号' }]" />
											<van-field v-model="item.personPhone" name="访客电话" label="访客电话" placeholder="请输入访客电话"
												:required="true" :rules="[{ required: true, message: '请填写访客电话' }]" />
											
											<!--健康码改为附件20240721-->
											<van-field name="uploader" label="附件" :required="false" :rules="[{ required: false, message: '请上传健康码' }]">
												<template #input>
													<van-uploader :name="1+','+index" :after-read="afterRead" :multiple="true" v-model="item.healthCodeList" />
												</template>
											</van-field>
											<!--健康码改为附件20240721-->
											<!--屏蔽掉健康码相关信息20240721-->
											<div v-if="$globalJKM">	
												<van-field v-model="item.nativePlace" name="籍贯" label="籍贯" placeholder="请输入籍贯(乡镇)"
													:required="true" :rules="[{ required: true, message: '请填写籍贯' }]" />
												<van-field v-model="item.apartment" name="目前居住地" label="目前居住地" placeholder="请输入目前居住地"
													:required="true" :rules="[{ required: true, message: '请填写目前居住地' }]" />
												
												<van-field name="radio" :required="true" label="发热咳嗽">
													<template #input>
														<van-radio-group v-model="item.hasCough" direction="horizontal">
															<van-radio :name="0">否</van-radio>
															<van-radio :name="1">是</van-radio>
														</van-radio-group>
													</template>
												</van-field>											
												<van-field name="uploader" label="健康码" :required="false" :rules="[{ required: false, message: '请上传健康码' }]">
													<template #input>
														<van-uploader :name="1+','+index" :after-read="afterRead" :multiple="true" v-model="item.healthCodeList" />
													</template>
												</van-field>											
												<van-field name="uploader" label="核酸检测报告">
													<template  #input>
														<van-uploader :name="3+','+index" :after-read="afterRead" :multiple="true"  v-model="item.acidCodeList"/>
													</template>
												</van-field>
											</div>
											<!--屏蔽掉健康码相关信息20240721-->
										</div>
										<div class="bor-top bgwhite flex between tc ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											<span class="blue w50" @click="addVis">+添加访客</span>											
										</div>
										
										<div style="position: fixed;bottom: 0;" class="flex w100">
											<van-button class="flex1 w47" style="border-right: 3px solid #fff" square @click="reset"  block type="info" native-type="button">重置</van-button>
											<van-button class="flex1 w50" square  block type="info" native-type="submit">提交</van-button>
										</div>
									</van-form>
								
							</div>
						</div>
					</van-tab>
					<van-tab title="报备历史">
						<div>
							<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
								<div class="autoFixed">
									<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
										<van-cell v-for="(item, index) in historyList" :key="index"
											style="margin-top: 20px; padding: 0">
											<div class="main">
												<div class="history-left" style="margin-top: 20px;">
													<div class="history-item">
														<span>审批对象姓名：</span>
														<span>{{ item.intervieweeName }}</span>
													</div>
													<div class="history-item">
														<span>审批对象手机号：</span>
														<span>{{ item.intervieweePhone }}</span>
													</div>
													<div class="history-item">
														<span>运输车队：</span>
														<span>{{ item.fleetName }}</span>
													</div>
													<div class="history-item">
														<span>运输物资：</span>
														<span>{{ item.goodsName }}</span>
													</div>
													<div class="history-item">
														<span>入厂时间：</span>
														<span>{{ item.interviewTime }}</span>
													</div>
													<div class="history-item">
														<span>
															驾驶员姓名：
															<span v-for="list,index1 in item.drivers" :key="index1">
																{{list.personName}}
																<span v-if="index1 < (item.drivers.length-1)&&item.drivers.length>1">、</span>
															</span>
														</span>
														<span>{{ item.personName }}</span>
													</div>
												</div>
												<div class="hisotry-right">
													<img v-if="item.checkStatus==0" src="@/assets/visitor/daishenhe.png"
														alt="" />
													<img v-if="item.checkStatus == 1" src="@/assets/visitor/agree.png"
														alt="" />
													<img v-if="item.checkStatus == 2" src="@/assets/visitor/reject.png"
														alt="" />
													<img class="quxiao" v-if="item.checkStatus == 9" src="@/assets/sushe/quxiao.png"
														alt="" />
												</div>
												<van-button plain type="info" size="small" class="userBtn"
													@click="cancleApp(item)" v-if="item.checkStatus==0">取消
												</van-button>
												<van-button plain type="primary" size="small" class="userBtn1"
													@click="getDetail(item)">详情
												</van-button>
												<van-button plain type="info" size="small" class="userBtn2"
													@click="goAgain(item)">重新预约
												</van-button>
											</div>
										</van-cell>
									</van-list>
								</div>
							</van-pull-refresh>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>
	</div>
</template>
<script>
	import tabs from "@/components/tabs.vue";
	import {
		getSysCategory,
		addTransport,
		transportHistory,
		transportCancel,
		registerCheck,
		uploadImg
	} from "@/apis/api";
	import {
		Toast,
		Dialog,
		ImagePreview,
	} from "vant";
	import {
		formatTime1
	} from "@/utils/index";
	export default {
		data() {
			return {
				historyList: [],
				carList: [],
				materialList: [],
				areaList: [],
				routeList: [],
				entranceList: [],
				pageNo:1,
				pageSize:10,
				total:0,
				isLoading: false,
				loading: false,
				finishedBottom: false,
				active: 0,
				list: [{
						name: "当前报备",
						type: "current",
					},
					{
						name: "报备历史",
						type: "history",
					},
				],
				minDate: new Date(2022, 1, 1),
				maxDate: new Date(2028, 10, 1),
				currentDate: new Date(),
				showForm:{},
				fleet: '',
				goods: '',
				unloadPlace: '',
				transportRoute: '',
				entry: '',
				appForm: {
					intervieweeName: '',
					intervieweePhone: '',
					interviewTime: '',
					leaveTime: '',
					fleet: '',
					plateNumber: '',
					goods: '',
					unloadPlace: '',
					transportRoute: '',
					entry: '',
					drivers:[
						{
							personName: '',
							personNo: '',
							personPhone: '',
							nativePlace: '',
							apartment: '',
							journey: '',
							hasCough: 0,
							hasRisk: 0,
							healthCode:'',
							routeCode: '',
							acidCode:'',
							healthCodeList: [],
							routeCodeList: [],
							acidCodeList: [],
						}
					]
				},
				show: false,
				nishow: false,
				showPicker: false,
				showCalendar: false,
				picker_v: 1,
				picker_car:'02',
				columns:[],
			};
		},
		mounted() {
			document.title = "车辆运输报备";
			this.nishow = true;
			// this.getSysCategory('C02');
			// this.getSysCategory('C03');
			// this.getSysCategory('C04');
			// this.getSysCategory('C05');
			// this.getSysCategory('C06');
		},
		methods: {
			
			imagePreview(item,list,index){
				var images,arr;
				if(index==1){
					if(item.healthCode.indexOf(';')!=-1){
						arr = item.healthCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.healthCode]
					}
					
				}else if(index==2){
					if(item.routeCode.indexOf(';')!=-1){
						arr = item.routeCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.routeCode]
					}
				}else if(index==3){
					if(item.acidCode.indexOf(';')!=-1){
						arr = item.acidCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.acidCode]
					}
				}
				console.log(images);
				ImagePreview({
				  images,
				  startPosition: list,
					closeable: true,
				});
			},
			getDetail(item){
				this.show = true;
				this.showForm = item;
			},
			goAgain(item){
				this.fleet = item.fleetName;
				this.goods = item.goodsName;
				this.unloadPlace = item.unloadPlaceName;
				this.transportRoute = item.transportRouteName;
				this.entry = item.entryName;
				this.appForm.intervieweeName = item.intervieweeName;
				this.appForm.intervieweePhone = item.intervieweePhone;
				this.appForm.interviewTime = item.interviewTime;
				this.appForm.leaveTime = item.leaveTime;
				this.appForm.fleet = item.fleet;
				this.appForm.plateNumber = item.plateNumber;
				this.appForm.goods = item.goods;
				this.appForm.unloadPlace = item.unloadPlace;
				this.appForm.transportRoute = item.transportRoute;
				this.appForm.entry = item.entry;
				this.appForm.drivers = item.drivers;
				this.appForm.drivers.forEach((items,index)=>{
					this.$set(this.appForm.drivers[index],'healthCode','')
					this.$set(this.appForm.drivers[index],'routeCode','')
					this.$set(this.appForm.drivers[index],'acidCode','')
					this.$set(this.appForm.drivers[index],'healthCodeList',[])
					this.$set(this.appForm.drivers[index],'routeCodeList',[])
					this.$set(this.appForm.drivers[index],'acidCodeList',[])
				})
				this.initContent(0)
			},
			// 添加访客按钮
			addVis(){
				this.appForm.drivers.push({
					personName: '',
					personNo: '',
					personPhone: '',
					nativePlace: '',
					apartment: '',
					journey: '',
					hasCough: 0,
					hasRisk: 0,
					healthCode:'',
					routeCode: '',
					acidCode:'',
					healthCodeList: [],
					routeCodeList: [],
					acidCodeList: [],
				})
				this.$set(this.appForm.drivers,this.appForm.drivers)
			},
			delVis(index,item){
				Dialog({ message: "提示" });
				Dialog.confirm({
					title: "提示",
					message: `确认删除司机${item.personName}吗？`,
				}).then(() => {
					if(this.appForm.drivers.length>1){
						this.appForm.drivers.splice(index,1)
					}
				}).catch(() => {
				});
			},
			// 选日期弹窗
			openPicker(picker_v) {
				this.picker_v = picker_v;
				this.showCalendar = true;
			},
			// 选日期弹窗
			onConfirm(date) {
				console.log(date);
				console.log(formatTime1('hm',date));
				if (this.picker_v == 1) {
					this.appForm.interviewTime = formatTime1('hm',date);
				} else {
					this.appForm.leaveTime = formatTime1('hm',date);
				}
				this.showCalendar = false;
			},
			cancel(){
				this.showCalendar = false;
			},
			// picker弹窗
			openPicker1(code) {
				if(this.picker_car != code)
				this.getSysCategory(code);
				this.picker_car = code
				this.showPicker = true;
			},
			// picker弹窗确定
			pickerConfirm(e){
				if(this.picker_car=="C02"){
					this.appForm.fleet=e.id;
					this.fleet=e.name;
				}else if(this.picker_car=="C03"){
					this.appForm.goods=e.id;
					this.goods=e.name;
				}else if(this.picker_car=="C04"){
					this.appForm.unloadPlace=e.id;
					this.unloadPlace=e.name;
				}else if(this.picker_car=="C05"){
					this.appForm.transportRoute=e.id;
					this.transportRoute=e.name;
				}else if(this.picker_car=="C06"){
					this.appForm.entry=e.id;
					this.entry=e.name;
				}
				this.showPicker = false;
			},
			pickerCancel(){
				this.showPicker = false;
			},
			getSysCategory(code,keyWord=''){
				let data={
					code,keyWord
				}
				getSysCategory(data).then((res) => {
					if(res.code==200){
						if(res.result.length){
							res.result.forEach((i,v)=>{
								i.text = i.name
							})
						}
						this.columns = res.result;
					}else{
						this.$toast(res.message);
					}
				});
			},
			// 校验姓名电话
			checkPhone(){
				let registerCheckModel = {
					name : this.appForm.intervieweeName,
					phone: this.appForm.intervieweePhone,
				}
				registerCheck(registerCheckModel).then((res) => {
					if(res.code==200){
						this.$toast('校验通过');
					}else{
						this.$toast(res.message); 
					}
				});
			},
			// 文件上传
			afterRead(file,params) {
				console.log(file);
				console.log(params);
				let code = params.name.split(',')[0]
				let index = params.name.split(',')[1]
				// 此时可以自行将文件上传至服务器
				if(Array.isArray(file)){
					for(let i =0;i<file.length;i++){
						file[i].file.status = 'uploading';
						file[i].file.message = '上传中...';
						uploadImg({
							img: file[i].content,
							openId: localStorage.getItem('openId'),
							ext: file[i].file.name.split('.')[1]
						}).then(res => {
							Toast('上传成功')
							if(code==1){
								this.appForm.drivers[index].healthCode +=(';'+res.result.savePath);
							}else if(code==2){
								this.appForm.drivers[index].routeCode += (';'+res.result.savePath);
							}else if(code==3){
								this.appForm.drivers[index].acidCode += (';'+res.result.savePath);
							}
							file[i].file.status = 'done';
							file[i].file.message = '上传成功';
						})
					}
				}else{
					file.status = 'uploading';
					file.message = '上传中...';
					uploadImg({
						img: file.content,
						openId: localStorage.getItem('openId'),
						ext: file.file.name.split('.')[1]
					}).then(res => {
						Toast('上传成功')
						if(code==1){
							this.appForm.drivers[index].healthCode +=(';'+res.result.savePath);
						}else if(code==2){
							this.appForm.drivers[index].routeCode +=(';'+res.result.savePath);
						}else if(code==3){
							this.appForm.drivers[index].acidCode +=(';'+res.result.savePath);
						}
						file.status = 'done';
						file.message = '上传成功';
					})
				}
				// setTimeout(()=>{
				// 	let str = this.appForm.drivers[index].healthCode
				// 	console.log(str.slice(0,1)==';'?str.slice(1):str);
				// },1200)
			},
			// 重置
			reset(){
				this.fleet='';
				this.goods='';
				this.unloadPlace='';
				this.transportRoute='';
				this.entry='';
				this.appForm = {
					intervieweeName: '',
					intervieweePhone: '',
					interviewTime: '',
					leaveTime: '',
					fleet: '',
					plateNumber: '',
					goods: '',
					unloadPlace: '',
					transportRoute: '',
					entry: '',
					drivers:[
						{
							personName: '',
							personNo: '',
							personPhone: '',
							nativePlace: '',
							apartment: '',
							journey: '',
							hasCough: 0,
							hasRisk: 0,
							healthCode:'',
							routeCode: '',
							acidCode:'',
							healthCodeList: [],
							routeCodeList: [],
							acidCodeList: [],
						}
					]
				}
			},
			// 校验失败
			failed(){
				console.log(111);
			},
			// 提交预约
			onSubmit() {
				// this.appForm.openId = localStorage.getItem('openId') || '';
				let arr = this.appForm.drivers;
				this.appForm.drivers = [];
				arr.forEach((i,v)=>{
					this.appForm.drivers.push({
						personName: i.personName,
						personNo: i.personNo,
						personPhone: i.personPhone,
						healthCode:i.healthCode.slice(0,1)==';'?i.healthCode.slice(1):i.healthCode,
						routeCode: i.routeCode.slice(0,1)==';'?i.routeCode.slice(1):i.routeCode,
						acidCode:i.acidCode.slice(0,1)==';'?i.acidCode.slice(1):i.acidCode,
						nativePlace: i.nativePlace,
						apartment: i.apartment,
						journey: i.journey,
						hasCough: i.hasCough,
						hasRisk: i.hasRisk,
					})
				})
				console.log(this.appForm);
				addTransport(this.appForm).then((res) => {
					if(res.code==200){
						this.$toast(res.message);
						this.reset();
					}else{
						this.$toast(res.message);
					} 
				});
			},
			// 获取历史
			getHistoryList() {
				this.onRefresh(1)
			},
			onRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				transportHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						if(index!=1){
							Toast("刷新成功");
						}
						this.historyList = res.result.records;
						this.total = res.result.total;
						if (this.historyList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			onLoad() {
				console.log("加载更多");
				if(this.isLoading)return
				this.pageNo++;
				transportHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						this.historyList = this.historyList.concat(res.result.records);
						if (this.historyList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 取消预约
			cancleApp(item){
				Dialog({
					message: "提示"
				});
				Dialog.confirm({
					title: "提示",
					message: "确认取消吗？",
				})
				.then(() => {
					transportCancel({
						uid: item.uid,
					}).then((res) => {
						if(res.code==200){
							Toast(res.message);
							this.getHistoryList()
						}else{
							Toast(res.message);
						}
					});
				})
				.catch(() => {
				});
			},
			
			
			initContent(value) {
				this.active = value;
				if (value == 0) {
					// 刷新页面
				} else {
					this.pageSize = 10;
					this.pageNo = 1;
					this.getHistoryList();
				}
			},
			
		},
		components: {
			tabs,
		},
	};
</script>

<style lang="less" scoped>
	body{
	   height:100%;
	}
	.homes {
		border-top: 1px solid #ccc;
		width: 100%;
		height:100%;
	}
	.modals {
		position: relative;
		height: 100%;
		padding-bottom:7vh !important;
	}
	.autoFixed {
		background: #f3f3f3;
		min-height: 100vh;
		padding:0 20px;
		position: relative;
		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597FF;
		}
		.userBtn1 {
			position: absolute;
			right: 20px;
			top: 85px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #55aa7f;
		}
		.userBtn2 {
			position: absolute;
			right: 20px;
			top: 150px;
			width: 134px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597ff;
		}
	
		.main {
			box-sizing: content-box;
			background: #ffffff;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			width: 100%;
			border-radius: 5px;
			padding:0 24px;
			box-sizing: border-box;
			position: relative;
			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}
	
			.hisotry-right {
				img {
					width: 150px;
					height: 150px;
				}
				.quxiao{
					width: 150px;
					height: 130px;
				}
			}
	
			.history-item {
				margin-bottom: 15px;
	
				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
</style>
